/** @tsx tsx */
import { TableCellProps } from "@material-ui/core/TableCell";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import React from "react";
import MaterialTableCell from "@material-ui/core/TableCell";
import {
  Sort,
  SortAscending,
  SortDescending,
} from "@nike/nike-design-system-icons";
import { useTokens } from "@nike/nike-design-system-components";
import styled from "@emotion/styled";
import { ColumnTypes, SortOrders } from "../helpers/types";

export interface HeaderCellProps extends TableCellProps {
  children: React.ReactNode;
  onSort: (property: ColumnTypes) => void;
  order: SortOrders;
  orderBy: string;
  property: string;
  sortable: boolean;
}

export function HeaderCell({
  children,
  onSort,
  order,
  orderBy,
  property,
  sortable,
  ...props
}: HeaderCellProps): JSX.Element {
  const tokens = useTokens();
  const active = orderBy === property;
  const sortDirection = active ? order : SortOrders.NONE;

  const getHeaderIcon = () => {
    if (!active) return <Sort width={25} />;
    if (sortDirection && sortDirection === "desc")
      return <SortDescending width={25} />;
    else return <SortAscending width={25} />;
  };

  const StyledHeaderCell = styled(MaterialTableCell)`
    &,
    & > span {
      cursor: ${({ onClick }) => (onClick ? "pointer" : "inherit")};
      color: ${({ sortDirection }) =>
        sortDirection
          ? tokens.podiumCdsColorTextPrimary
          : tokens.podiumCdsColorTextSecondary} !important;
      font: ${() => tokens.podiumCdsTypographyBody1};
    }

    &:hover,
    &:hover > span {
      background-color: ${({ onClick }) =>
        onClick ? tokens.paletteGrey4 : "inherit"};
      color: ${({ onClick }) =>
        onClick
          ? tokens.podiumCdsColorTextPrimary
          : tokens.podiumCdsColorTextSecondary} !important;
    }

    svg:not(.eds-icon) {
      opacity: ${!active ? "0" : "0.4"};
      transition: "opacity 0.4s ease";
    }

    &:hover svg:not(.eds-icon) {
      opacity: ${active ? "1" : "0.4"};
      transition: "opacity 0.4s ease";
    }
  `;

  return (
    <StyledHeaderCell
      sortDirection={
        sortDirection === SortOrders.NONE ? undefined : sortDirection
      }
      onClick={() => onSort(property as ColumnTypes)}
      {...props}
    >
      {sortable ? (
        <TableSortLabel active={active} IconComponent={() => getHeaderIcon()}>
          {children}
        </TableSortLabel>
      ) : (
        children
      )}
    </StyledHeaderCell>
  );
}
